import React from 'react';
import { Label } from '../../../components/ui/label';

interface OnboardingToggleProps {
  checked: boolean;
  onChange: (enabled: boolean) => void;
}

/**
 * Onboarding Toggle Component
 * Toggle for enabling/disabling the onboarding flow
 */
export const OnboardingToggle: React.FC<OnboardingToggleProps> = ({ checked, onChange }) => {
  return (
    <div className="flex items-center justify-between p-4 border border-border rounded-lg bg-muted/30">
      <div className="flex-1">
        <Label htmlFor="enable-onboarding" className="text-sm font-medium cursor-pointer">
          Enable Onboarding Flow
        </Label>
        <p className="text-sm text-muted-foreground mt-1">
          Show onboarding wizard for new users when they first access Engage. Defaults to enabled if not
          specified.
        </p>
      </div>
      <div className="ml-4">
        <input
          id="enable-onboarding"
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
        />
      </div>
    </div>
  );
};
